import { create } from 'zustand'
import { omit } from 'lodash'
import type { TGqlOperationName } from 'gql/names.types'

interface IOperationStatusState {
  loadingOperations: TGqlOperationName[]
  operationErrors: Partial<Record<TGqlOperationName, string | null>>
  startLoading: (operationName: TGqlOperationName) => void
  stopLoading: (operationName: TGqlOperationName) => void
  setError: (operationName: TGqlOperationName, error: string | null) => void
}

export const useOperationStatusStore = create<IOperationStatusState>((set) => ({
  loadingOperations: [],
  operationErrors: {},

  startLoading: (operationName) => {
    set((state) => ({
      loadingOperations: [...state.loadingOperations, operationName],
      operationErrors: state.operationErrors[operationName]
        ? omit(state.operationErrors, operationName)
        : state.operationErrors,
    }))
  },

  stopLoading: (operationName) => {
    set((state) => ({
      loadingOperations: state.loadingOperations.filter((name) => name !== operationName),
    }))
  },

  setError: (operationName, error) => {
    set((state) => ({
      operationErrors: {
        ...state.operationErrors,
        [operationName]: error,
      },
    }))
  },
}))
